module.exports = __webpack_public_path__ + "77a9733733d46e11c28a67a3c9095c22.svg";